import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useTramiteStatus } from '@/common/hooks/useTramiteStatus';
import type { TramiteStatusProps } from './types';
import { useTramiteStatusSummary } from '../TramiteStatusSummary/useTramiteStatusSummary';

interface TramiteStatusDisplayProps extends TramiteStatusProps {
  showLabel?: boolean;
  labelText?: string;
}

const TramiteStatusDisplay: React.FC<TramiteStatusDisplayProps> = ({
  tramite,
  showLabel = true,
  labelText = 'Estado:',
  onClick,
  clickable = false
}) => {
  const { config, displayText } = useTramiteStatus(tramite);
  const {
    completed,
    totalEnabled,
  } = useTramiteStatusSummary(tramite);

  const handleClick = () => {
    if (clickable && onClick) {
      onClick(tramite);
    }
  };

  return (
    <div className="flex flex-col space-y-1">
      {showLabel && (
        <div className="font-semibold text-sm">
          {labelText}
        </div>
      )}
      <div>
        <Badge
          variant={config.variant}
          className={`${config.className} ${clickable ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
          onClick={handleClick}
        >
          {displayText}
          <span className="ml-2 text-xs font-mono">
            ({completed}/{totalEnabled})
          </span>
        </Badge>
      </div>
    </div>
  );
};

export default TramiteStatusDisplay;